import { buildModelManager } from "../builder.js";
const DefaultCohortMembershipSelection = {
  __typename: true,
  id: true,
  active: true,
  assignedAt: true,
  assignedById: true,
  clinicalShiftCount: true,
  cohortId: true,
  createdAt: true,
  erroredShifts: true,
  fieldShiftCount: true,
  hasFisdapReviewAccess: true,
  hasScenarioGeneratorAccess: true,
  labShiftCount: true,
  lastShiftSubmittedAt: true,
  notificationPreferences: true,
  passingShiftCount: true,
  primaryRole: true,
  subRoles: true,
  teamLeadShiftCount: true,
  totalClinicalSubmissions: true,
  totalFieldSubmissions: true,
  totalLabSubmissions: true,
  totalShiftCount: true,
  totalSubmissions: true,
  totalTeamLeadSubmissions: true,
  totalValidShifts: true,
  updatedAt: true,
  userEmail: true,
  userId: true,
  validClinicalShifts: true,
  validFieldShifts: true,
  validLabShifts: true,
  validTeamLeadShifts: true
};
const modelApiIdentifier = "cohortMembership";
const pluralModelApiIdentifier = "cohortMemberships";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCohortMembershipSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCohortMembership",
    operationReturnType: "CreateCohortMembership",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      cohortMembership: { required: false, type: "CreateCohortMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCohortMemberships",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateCohortMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "action",
    operationName: "updateCohortMembership",
    operationReturnType: "UpdateCohortMembership",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      cohortMembership: { required: false, type: "UpdateCohortMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCohortMemberships",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateCohortMembershipsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "action",
    operationName: "deleteCohortMembership",
    operationReturnType: "DeleteCohortMembership",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCohortMemberships",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCohortMembership",
    operationReturnType: "UpsertCohortMembership",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      cohortMembership: { required: false, type: "UpsertCohortMembershipInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCohortMembershipResult": { hasReturnType: false },
      "... on UpdateCohortMembershipResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCohortMemberships",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertCohortMembershipsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCohortMembershipSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "cohortMembershipGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const CohortMembershipManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCohortMembershipSelection,
  operations
);
export {
  CohortMembershipManager,
  DefaultCohortMembershipSelection
};
//# sourceMappingURL=CohortMembership.js.map
